module.exports = __webpack_public_path__ + "img/PRCA2_Endothelial.85e0ed44.png";